/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from 'react';
import { Link } from 'react-router-dom';
// BASE components
import BASESvgIcon from '../../../@BASE/core/BASESvgIcon';
import useThemeMediaQuery from '../../../@BASE/hooks/useThemeMediaQuery';
// Material-UI components
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
// Custom components
import EmptyCommentsCard from './snapshots/EmptyCommentsCard';
import CommentsOverview from './snapshots/CommentsOverview';

function CommentCard({ commentSummary, productionCommentSummary, resource }) {
  const allZero = Object.values(commentSummary).every((value) => value === 0);

  if (!commentSummary || allZero) {
    return (
      <div className="w-full">
        <div className="mb-32 space-y-16">
          <Typography className="grow text-2xl font-bold tracking-tight leading-none py-8">
            Comments
          </Typography>
          <Divider />
          <Paper className="flex flex-col flex-auto p-24 shadow rounded-xl overflow-hidden">
            <div className="flex items-center justify-between">
              <div className="flex flex-col">
                <Typography className="text-lg font-medium tracking-tight leading-6 truncate">
                  Comment Overview
                </Typography>
                <Typography
                  className="text-md font-medium"
                  color="text.secondary"
                >
                  {resource} Comment Snapshot
                </Typography>
              </div>
            </div>
            <div className="my-32 space-y-32">
              <EmptyCommentsCard resource={resource.toLowerCase()} />
            </div>
          </Paper>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full">
      <div className="mb-32 space-y-16">
        <Typography className="grow text-2xl font-bold tracking-tight leading-none py-8">
          Comments
        </Typography>
        <Divider />
        <Paper className="flex flex-col flex-auto p-24 shadow rounded-xl overflow-hidden">
          <div className="flex items-center justify-between">
            <div className="flex flex-col">
              <Typography className="text-lg font-medium tracking-tight leading-6 truncate">
                Comment Overview
              </Typography>
              <Typography
                className="text-md font-medium"
                color="text.secondary"
              >
                {resource} Comment Snapshot
              </Typography>
            </div>
          </div>
          <div className="my-32 space-y-32">
            <div className="flex flex-col">
              <div className="flex items-center">
                <BASESvgIcon className="text-current" size={20}>heroicons-outline:document-text</BASESvgIcon>
                <Typography
                  className="text-md font-medium mx-8 flex-1"
                >
                  Storyboard Comments
                </Typography>
                <IconButton 
                  to="comments"
                  component={Link}
                  aria-label="Go to Storyboard comments"
                >
                  <BASESvgIcon>heroicons-outline:arrow-sm-right</BASESvgIcon>
                </IconButton>
              </div>
              <CommentsOverview commentSummary={commentSummary} resource={resource} />
            </div>
            <div className="flex flex-col">
              <div className="flex items-center">
                <BASESvgIcon className="text-current" size={20}>heroicons-outline:desktop-computer</BASESvgIcon>
                <Typography
                  className="text-md font-medium mx-8 flex-1"
                >
                  Production Comments
                </Typography>
                <IconButton 
                  to="imi-comments"
                  component={Link}
                  aria-label="Go to Production comments"
                >
                  <BASESvgIcon>heroicons-outline:arrow-sm-right</BASESvgIcon>
                </IconButton>                  
              </div>
              <CommentsOverview commentSummary={productionCommentSummary} resource={resource} />
            </div>
          </div>
        </Paper>
      </div>
    </div>
  );
}

export default CommentCard;
